import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

function DailyTargetReachedModal({ show = true, duration, onHide }) {
  const [showModal, setShowModal] = useState(show);

  const handleClose = () => {
    setShowModal(false);
    if (onHide) {
      // delay the onHide function to allow the modal to close first
      setTimeout(() => onHide(), 1000);
    }
  };

  useEffect(() => {
    let timer;
    if (duration) {
      timer = setTimeout(handleClose, duration);
    }
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [duration]);

  return (
    <Modal show={showModal} onHide={handleClose} centered size="md">
      <Modal.Body>
        <div className="p-3">
          <img
            src={require("@/assets/gifs/jonah-hill-excited.gif")}
            alt="Target"
            className="img-fluid mx-auto d-block rounded-4"
          />
          {/* <img
              src={require("@/assets/illustrations/target.png")}
              alt="Target"
              className="img-fluid mx-auto d-block "
              style={{ maxWidth: "300px" }}
            /> */}
          <div className="text-center mt-3">
            <h2 className="fw-bold">Daily Target Achieved!</h2>
            <p className="text-muted">We have reached our daily target.</p>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default DailyTargetReachedModal;
